"use client";

import { createContext } from "react";

import type {
  VariantAvailability,
  VariantSelection,
} from "~/components/product/variant/availability";
import type { PdpOption, PdpVariant } from "~/server/api/schemas/pdp";

export interface VariantContextValue {
  selected: VariantSelection;
  resolvedVariant: PdpVariant | undefined;
  availability: VariantAvailability;
  isComplete: boolean;
  firstUnmetOption: PdpOption | null;
  validationMessage: string | null;
  selectOption: (optionId: string, optionValueId: string) => void;
  clearOption: (optionId: string) => void;
}

export const VariantContext = createContext<VariantContextValue | null>(null);
